function RemergeLogoText() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      height="60px"
      viewBox="0 0 1500 480"
      className="fill-black dark:fill-white"
    >
      <g>
        <path
          d="M216.6,124.4c0,13.6-3.9,23.8-11.6,30.6s-19.6,10.3-35.2,10.3h-68.7V83.2h68.3c15.8,0,27.8,3.5,35.5,10.3
		S216.6,110.7,216.6,124.4 M195.6,186.5c16.5-3.7,28.5-10.2,36.8-20c8.9-10.5,13.2-24.4,13.2-42.4c0-22.1-6.5-39.1-19.2-50.5
		s-31.8-17.3-56.6-17.3H72.5v271.5h28.6V191.9h53.3c17.1,0,30.1,5.2,39.5,15.9c8.5,9.6,14.2,23.8,17.5,43.3l12.8,75.6l0.2,1.1h31.6
		l-14.9-79.9C235.5,216.8,225.5,194.6,195.6,186.5"
        />
        <path
          d="M1295,195.9c6.1-37.2,26.3-59.4,54.2-59.4c28.3,0,47.8,22.8,51,59.4H1295z M1407.9,255.7l-0.5,1.4
		c-12.8,33.5-30.4,49-55.2,49c-17.6,0-32.4-8-42.8-23c-10.5-15.2-16-37.1-16-63.1v-0.2h136v-7.5c0-29.6-7.7-54.9-22.3-73.2
		s-34.6-28-57.8-28c-49.1,0-83.4,45.6-83.4,110.8c0,32.6,8.2,60.3,23.7,80.2s37.4,30.6,63,30.6c18.2,0,34.1-5.5,47.2-16.4
		s23.5-27.1,31.4-48.6l0.4-1.2L1407.9,255.7z"
        />
        <path
          d="M1116.3,182.6c0-27.9,19-46.6,47.4-46.6s47.4,18.9,47.4,47c0,27.9-19.1,46.6-47.4,46.6
		S1116.3,210.7,1116.3,182.6 M1233.6,348.3c0,9.5,0,38.3-66.9,38.3c-44.4,0-67-12.7-67-37.9c0-14.8,9.2-27.2,24.7-33.3
		c5,0.4,10.4,0.8,16.1,0.8h49C1218.3,316.2,1233.5,327.3,1233.6,348.3 M1195.7,289.4h-54.3c-22,0-34.6-8.4-34.6-22.9
		c0-9.5,6.2-17.6,17.1-22c11.7,6,25.2,9.1,39.9,9.1c45.7,0,76.3-28.5,76.3-70.9c0-20.2-7.1-37.6-20.6-50.5
		c5.4-14.1,16.9-21.5,33.2-21.5h13.4V83.8h-12.5c-24.7,0-42.3,13.2-49.5,37.1c-11.6-5.8-25.2-8.8-40.2-8.8
		c-45.7,0-76.3,28.3-76.3,70.5c0,20.2,7.2,37.9,21,51.2c-18.6,7.3-28.9,21.5-28.9,40.2c0,11.6,4.1,27,23.5,35.6
		c-20.8,7.3-33.1,23.6-33.1,44.1c0,26.7,16.2,58.5,93.4,58.5c65,0,100.8-23.3,100.8-65.5c0-37.5-23.7-57.2-68.5-57.2"
        />
        <path
          d="M790.5,195.9c6.1-37.2,26.3-59.4,54.2-59.4c28.3,0,47.8,22.8,51,59.4H790.5z M902.9,257
		c-12.9,33.5-30.4,49-55.3,49c-17.6,0-32.4-8-42.8-23c-10.5-15.2-16-37.1-16-63.1v-0.2h136v-7.5c0-29.6-7.7-54.9-22.3-73.2
		s-34.5-28-57.8-28c-49.1,0-83.4,45.6-83.4,110.8c0,32.6,8.2,60.3,23.7,80.2s37.4,30.6,63,30.6c18.2,0,34.1-5.5,47.2-16.4
		s23.5-27.1,31.4-48.6l0.4-1.2l-23.6-10.7L902.9,257z"
        />
        <path
          d="M301.9,195.9c6.1-37.2,26.3-59.4,54.2-59.4c28.3,0,47.8,22.8,51,59.4H301.9z M414.2,257
		c-12.9,33.5-30.4,49-55.2,49c-17.6,0-32.4-8-42.8-23c-10.5-15.2-16-37.1-16-63.1v-0.2h136v-7.5c0-29.6-7.7-54.9-22.3-73.2
		s-34.6-28-57.8-28c-49.1,0-83.4,45.6-83.4,110.8c0,32.6,8.2,60.3,23.7,80.2s37.4,30.6,63,30.6c18.2,0,34.1-5.5,47.2-16.4
		s23.5-27.1,31.4-48.6l0.4-1.2l-23.6-10.7L414.2,257z"
        />
        <path
          d="M667.1,113.8c-26.3,0-46.2,12.4-54.6,34H611v-31.4h-69.1c-23.8,0-38.3,10.6-45.4,33.4h-26.3v177.9h27.6V209.4
		c0-45.9,13.8-68.2,42-68.2h46v186.6h27.7V193c0-31.7,19.6-53.8,47.6-53.8c24.2,0,40.4,18.6,40.4,46.3v142.3h27.7V181.2
		C729.2,140.3,704.8,113.8,667.1,113.8"
        />
        <path
          d="M1070.2,116.5h-38.4c-23.8,0-38.3,10.6-45.3,33.4h-26.3v177.9h27.7V209.4c0-45.9,13.8-68.2,42-68.2h40.3
		L1070.2,116.5z"
        />
      </g>
    </svg>
  );
}

export default RemergeLogoText;
